import React, {Component} from 'react';
import { connect } from "react-redux";
import { Form, ScrollView } from 'devextreme-react';
import * as apis from '../../utils/apis';
import axios from 'axios';
import notify from 'devextreme/ui/notify';
import { notificationTiming } from '../../utils/appConfig';


class ReRouteQueryPopup extends Component {
    
    updateQuery = (params) => {

        var result = params.validationGroup.validate();
        
        if(result.isValid) {

        let data = {
            queryId: this.props.query.id,
            allocatedGroupId: this.props.query.userGroupId
        }
    
        axios.post('api/queries/updateQuery', data)
        .then(response => {  
            notify("Query updated successfully.","success", notificationTiming);
            this.props.queryUpdatedHandler()
        })
        .catch(error => {
            console.log(error);
      
            notify(error.response.data,"error", notificationTiming);
           
           
        });
       }
    }
   

    render() {

        let formConfig = {
            items : [
                {
                    itemType: "group",
                    colCount: 6,
                    colSpan: 6,
                    items: [
                        
                        {
                            dataField: 'queryIdentifier',
                            colSpan: 1,
                            editorOptions: {
                                readOnly: true
                            },
                            label : { text: "Query #"},
                            
                        },
                        {
                            dataField: 'claimedBy',
                            colSpan: 1,                    
                            editorOptions: {
                                readOnly: true
                            },
                            label : { 
                                text: "Claimed by"},
                        },
                        {
                            dataField: 'queryStatusId',
                            colSpan: 1,
                            editorType: "dxSelectBox",
                            editorOptions: {
                                displayExpr: 'description',
                                valueExpr: 'id',
                                dataSource: apis.QueryStatusDataSource(this.props.user.access_token),
                                readOnly: true
                            },
                            label : { 
                                text: "Status"
                            },
                               
                        },
                        {
                            dataField: 'userGroupId',
                            colSpan: 1,
                            editorType: "dxSelectBox",
                            editorOptions: {
                                displayExpr: 'name',
                                valueExpr: 'id',
                                dataSource: apis.UserGroupWithAccessDataSource(this.props.user.access_token),
                                readOnly: false
                            },
                            label : { 
                                text: "Responsible"
                            },
                            validationRules: [{
                                type: "required",
                                message: "Responsible Group Is Required"
                            },]
                               
                        },
                        {
                            dataField: 'raisedBy',
                            colSpan: 1,                    
                            editorOptions: {
                                readOnly: true
                            },
                            label : { 
                                text: "Raised by"},
                        },
                        {
                            dataField: 'dateOpened',
                            colSpan: 1,                    
                            editorType: "dxDateBox",
                            editorOptions: {
                                displayFormat: "dd/MM/y",
                                readOnly: true
                            },
                            label : { 
                                text: "Date Opened"},
                        },
                        
                        
                    ]
                },
                {
                    dataField: 'closedBy',
                    colSpan: 3,
                    editorOptions: {
                        readOnly: true
                    },
                    label : { text: "Resolved By"},

                },
                {
                    dataField: 'dateResolved',
                    colSpan: 3,
                    editorType: "dxDateBox",
                        editorOptions: {
                            displayFormat: "dd/MM/y",
                            readOnly: true
                        },
                    label : { text: "Date Resolved"},

                },
                {
                    dataField: 'question',
                    colSpan: 6,
                    editorType: "dxTextArea",
                    editorOptions: {
                        height: "150px",
                        readOnly: true
                    },
                    label: {
                        text: "Question"
                    }

                },
                {
                    dataField: 'response',
                    colSpan: 6,
                    editorType: "dxTextArea",
                    editorOptions: {
                        height: "150px",
                        readOnly: true
                    },
                    label: {
                        text: "Response"
                    }

                },
                 {
                    itemType: "button",
                    horizontalAlignment: "right",
                    colSpan: 6,
                    buttonOptions: {
                        text: "Save Query",
                        type: "success",
                        useSubmitBehavior: false,
                        onClick: this.updateQuery
                    }
                },
               
                
               
            ]


    }

        let output = null;

       

        if(this.props.query) {
            output = 
            <ScrollView>
                <Form formData ={this.props.query} items={formConfig.items} colCount={6}>

                </Form>
            </ScrollView>
   
        }
        return (
            <div style={{height: '100%'}}>
            { output }
            </div>
          
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.oidc.user,
        query : state.queryDetail.rowData
    };
  }

export default connect(mapStateToProps,null)(ReRouteQueryPopup)